import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "PageDetailFilter" })
export default class PageDetailFilter extends Vue {
    public localizer: any = Localizer;
    public filterData: any = { year: null, category: null, downloadlanguage: null };

    @Prop() readonly categories: string[];
    @Prop() readonly years: string[];
    @Prop() readonly downloadLanguages: string[];

    get routes() {
        return (<any>window).App.routes;
    }

    public created() {
        const url = new URL(window.location.href);
        this.filterData.category = url.searchParams.get("category");
        this.filterData.year = url.searchParams.get("year");
        this.filterData.downloadlanguage = url.searchParams.get("downloadlanguage");
    }

    public setFilterData(searchParam: string) {
        const urlSearchParams = new URLSearchParams(window.location.search);
        switch (searchParam) {
            case "category":
                this.filterData.category ? urlSearchParams.set('category', this.filterData.category) : urlSearchParams.delete('category');
                break;
            case "year":
                this.filterData.year ? urlSearchParams.set('year', this.filterData.year) : urlSearchParams.delete('year');
                break;
            case "downloadlanguage":
                this.filterData.downloadlanguage ? urlSearchParams.set('downloadlanguage', this.filterData.downloadlanguage) : urlSearchParams.delete('downloadlanguage');
                break;
        }

        urlSearchParams.delete('page');

        const updatedSearchString = urlSearchParams.toString();

        const newUrl = updatedSearchString ? `${window.location.pathname}?${updatedSearchString}` : window.location.pathname;

        // Reload the page with the updated URL
        window.location.href = newUrl;
    }
}